import * as actions from "./actions";

let initialState = {};

const uc = (state = initialState, action) => {
  switch (action.type) {
    // GET REPORTS
    case actions.USER_UC_REPORTS_GET_REQUEST:
      return Object.assign({}, state, {
        [action.correlation.accountId]: Object.assign(
          {},
          state[action.correlation.accountId],
          {
            data: null,
            fetching: true,
            fetchError: null,
          },
        ),
      });
    case actions.USER_UC_REPORTS_GET_SUCCESS:
      return Object.assign({}, state, {
        [action.correlation.accountId]: Object.assign(
          {},
          state[action.correlation.accountId],
          {
            fetching: false,
            fetched: true,
            data: action.response,
          },
        ),
      });
    case actions.USER_UC_REPORTS_GET_ERROR:
      return Object.assign({}, state, {
        [action.correlation.accountId]: Object.assign(
          {},
          state[action.correlation.accountId],
          {
            fetching: false,
            fetchError: action.error,
          },
        ),
      });
    default:
      return state;
  }
};

export default uc;
